import { processFilterValue } from "@/lib/filters";
import { UseDataTableOptions } from "@/types/dataTableSettings";
import { QueryKey } from "@tanstack/react-query";
import { useMemo } from "react";

export const useDynamicQueryParams = <P>(
  name: string | string[],
  options: Pick<UseDataTableOptions<P>, "filters" | "sorting">,
  extras?: Record<string, unknown>,
): QueryKey => {
  const queryKey: QueryKey = useMemo(() => {
    const { filters, sorting } = options;

    // Process filter values for cache key (trim/normalize)
    const trimmedData = filters.map(({ id, value }) => ({
      id,
      value: {
        ...value,
        // processFilterValue returns string[] for cache key purposes
        value: processFilterValue(value.value ?? ""),
      },
    }));

    const nameArr = Array.isArray(name) ? name : [name];

    return [
      ...nameArr,
      trimmedData.length && JSON.stringify(trimmedData),
      sorting.length && JSON.stringify(sorting),
      extras && JSON.stringify(extras),
    ].filter(Boolean);
  }, [extras, name, options]);

  return queryKey;
};
